import { defineComponent as _defineComponent } from 'vue'
import { Wallet } from 'ah-api-gateways';
import { commonCurrencies } from 'ah-common-lib/src/helpers/currency';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useWalletState } from 'ah-wallets';
import { ref } from 'vue';
import { RawLocation } from 'vue-router';
import { useRouter } from 'vue-router/composables';
import AmountDisplay from '@/app/components/wallets/AmountDisplay.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletsDashboardWidget',
  props: {
    redirectTo: null
  },
  setup(__props: any) {

const props = __props as {
  redirectTo: RawLocation;
};



const router = useRouter();

const onBehalfOfClient = useOnBehalfOf();

const wallets = ref<{ currency: string; label: string; wallet: Wallet | null }[]>([
  {
    currency: 'GBP',
    label: commonCurrencies['GBP'],
    wallet: null,
  },
  {
    currency: 'EUR',
    label: commonCurrencies['EUR'],
    wallet: null,
  },
  {
    currency: 'USD',
    label: commonCurrencies['USD'],
    wallet: null,
  },
]);
function loadWallets() {
  wallets.value.forEach((walletObj) => {
    useWalletState()
      .store.useWalletsStore()
      .loadCurrencyWallet({
        currency: walletObj.currency,
        force: true,
        owner: onBehalfOfClient.value ? { isPartner: false, id: onBehalfOfClient.value.id } : undefined,
      })
      .then((res) => (walletObj.wallet = res));
  });
}
loadWallets();

function goToWallets() {
  router.push(props.redirectTo);
}

return { __sfc: true,props, router, onBehalfOfClient, wallets, loadWallets, goToWallets, AmountDisplay }
}

})